// extracted by mini-css-extract-plugin
module.exports = {"nav_list_item":"NavItem-module--nav_list_item--3UQvz","menu":"NavItem-module--menu--2On8d","visible":"NavItem-module--visible--5nsbw"};